export const type2List = [
  { label: '日榜', value: 1 },
  { label: '总榜', value: 2 }
]
